import React, { use, useEffect, useRef, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useSchool } from '../../DataStore/SchoolContext';
import { useTheme } from '../../DataStore/ThemeContext';
import Pagination from '../../components/Common/Pagination';
import { useFeesDefaulter } from '../../DataStore/FeesDefaulterContext';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import functions from '../../util/functions';
import DefaulterListHead from '../../components/SchoolFees/DefaulterListHead';
import printContent from '../../util/araknerdlib';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ImportDefaultersModal from '../../components/SchoolFees/ImportDefaultersModal';
import ConfirmationDialog from '../../components/Common/ConfirmationDialog';
import ajaxSchool from '../../util/remote/ajaxSchool';

const FeesDefaulterPage = () => {

    const {getClasses, getResidences} = useSchool();
    const {setNotify} = useTheme();
    const {getFeesDefaulterListing, feesDefaulterListing, metaData, setCurrentPage, searchText} = useFeesDefaulter();
    const statementRef = useRef(); // Ref to enclose statement content for printing
    const [showImportModal, setShowImportModal] = useState(false);
    const [showPurgeModal, setShowPurgeModal] = useState(false);

    useEffect(()=>{
        getClasses();
        getResidences();
        if(!feesDefaulterListing){
            getFeesDefaulterListing();
        }
    }, [])

    const exportDefaultersToExcel = (rows = []) => {
  if (!Array.isArray(rows) || rows.length === 0) return;

  // Build flat data (clean columns)
  const data = rows.map((item, idx) => ({
    "#": idx + 1,
    "Student Name": item?.student?.full_name || "",
    "Gender": item?.student?.gender || "",
    "Reg No.": item?.student?.reg_no || "",
    "Class": item?.student?.class?.class_name || "",
    "Residence": item?.student?.residence?.residence_name || "",
    "Balance": Number(item?.balance || 0),
    "Home Contact": item?.student?.home_contact || "",
    "Payment Code": item?.student?.payment_code || "",
  }));

  const ws = XLSX.utils.json_to_sheet(data);

  // Set column widths (optional but makes it look professional)
  ws["!cols"] = [
    { wch: 4 },   // #
    { wch: 26 },  // Student Name
    { wch: 10 },  // Gender
    { wch: 14 },  // Reg No
    { wch: 12 },  // Class
    { wch: 16 },  // Residence
    { wch: 14 },  // Balance
    { wch: 16 },  // Home Contact
    { wch: 14 },  // Payment Code
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Defaulters");

  // Write to array buffer
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

  const today = new Date().toISOString().slice(0, 10);
  const filename = `School_Fees_Defaulters_${today}.xlsx`;

  saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);
};



   
// Filtered students based on searchText
const filteredTransactions = Array.isArray(feesDefaulterListing)
    ? feesDefaulterListing.filter(
            (transaction) =>
                transaction.student.full_name?.toLowerCase().includes(searchText.toLowerCase()) ||
                transaction.student.reg_no?.toLowerCase().includes(searchText.toLowerCase()) ||
                transaction.balance?.toLowerCase().includes(searchText.toLowerCase())

        )
    : [];


const purgeDefaulters = async()=>{
    const response = await ajaxSchool.purgeImportedDefaulters();
    if(response.status === "OK"){
        await getFeesDefaulterListing(true);
        setNotify(<Notification type="success" message={response.message} closable={false}/>);
    }else{
        setNotify(<Notification type="danger" message={response.message} closable={false}/>);
    }
}
   

    const PageActions = ()=>(<>
         <ActionDropdownItem iconClass="fa fa-print" label="Print List" onClick={()=>printContent(statementRef, "School Fees Defaulters")}/>
        <ActionDropdownItem iconClass="fa fa-file-excel" label="Export to Excel" onClick={()=>exportDefaultersToExcel(filteredTransactions)}/>
        <ActionDropdownItem iconClass="fa fa-upload" label="Import Defaulters" onClick={()=>setShowImportModal(true)}/>
        <ActionDropdownItem className='text-danger' iconClass="fa fa-trash" label="Purge Imports" onClick={()=>setShowPurgeModal(true)}/>
        <ActionDropdownItem iconClass="fa fa-refresh" label="Refresh" onClick={()=>getFeesDefaulterListing(true)}/>
        </>)


    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="School Fees Defaulters"
                    description="View school fees defaulters."
                    iconClass="fa fa-handshake"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                        loadMore={true}
                /> : <></>}
                />
                {/* {notify}
                {currentNotify} */}
                 <DefaulterListHead
                     handleExport={() => exportDefaultersToExcel(filteredTransactions)} 
                     />
                <div className="card">
                    <div className="card-body">

                      <div ref={statementRef} className='table-responsive'>
                        <table className="table table-hover table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>Student Name</th>
                                    <th>Gender</th>
                                    <th>Reg No.</th>
                                    <th>Class</th>
                                    <th>Residence</th>
                                    <th>Balance</th>
                                    <th>Home Contacts</th>
                                    <th>Payment Code</th>
                                </tr>
                            </thead>
                            <tbody>
                             {Array.isArray(filteredTransactions) && filteredTransactions.map((item)=>
                                <tr key={item.student.id}>
                                    <td>{item.student.full_name}</td>
                                    <td>{item.student.gender}</td>
                                    <td>{item.student.reg_no}</td>
                                    <td>{item.student.class?.class_name || ''}</td>
                                    <td>{item.student.residence?.residence_name || ''}</td>
                                    <td>{functions.numberFormat(item.balance)}</td>
                                    <td>
                                        {Array.isArray(item.student.contacts) && item.student.contacts.map((contact, index)=><div key={index}>
                                            {contact.contact_name} : {contact.contact}
                                            </div>)}
                                    </td>
                                    <td>{item.student.payment_code}</td>

                                </tr>
                            )}

                            </tbody>
                        </table>
                        </div>
                    {!feesDefaulterListing && <ActivityLoader />}
                        {filteredTransactions.length === 0 && (
                            <Notification message="No defaulter record found." closable={false} />
                        )}
                    
                    </div>
                </div>               


               
                
            </MainContent>
        </PageContainer>
        <ImportDefaultersModal
            show={showImportModal}
            onClose={()=>setShowImportModal(false)}
            onImport={async()=>{await getFeesDefaulterListing(true);}}
        />
        <ConfirmationDialog
            show={showPurgeModal}
            handleClose={()=>setShowPurgeModal(false)}
            handleConfirm={purgeDefaulters}
            title="Purge Imports"
            alertDescription="Are you sure you want to purge all imported defaulters? This action cannot be undone."
            notes="All previously added student balances will be deleted and cannot be recovered. Only proceed if you intend to start fresh with new imports."
            buttonLabel='Purge Balances'
        />
        </>
    );
};

export default FeesDefaulterPage;
